import React, { useMemo } from "react";
import { Calendar as BigCalendar } from "react-big-calendar";

import { momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "./styles/styles.scss";
import "./styles/custom.scss";

import {
  TimeSlot,
  ResourceHeader,
  ResourceEvent,
  Agenda,
  AgendaTime,
} from "./components/Misc";
import Toolbar from "./components/Toolbar";

import { useDispatch, useSelector } from "react-redux";
import { uniqBy } from "lodash";
import MyCustomAgendaComponent from "components/CustomAgendaView/CustomAgendaView";
import { useLocation } from "react-router";
import queryString from "query-string";
import { replace } from "connected-react-router";


function Calendar({
  showFilter,
  setShowFilter,
  style = {},
  staff,
  facilities = [],
  isFetchingFacilities,
  date,
  setDate,
  bookAnAppointmentClick,
  appointmentDetailClick,
  currentFacilityIds,
  view,
  setView,
}) {
  const { bookings } = useSelector((state) => {
    return {
      bookings: state.bookings,
    };
  });
  const { dailyBookings } = bookings;
  const { components, localizer } = useMemo(
    () => ({
      components: {
        toolbar: (params) => (
          <Toolbar
            {...params}
            showFilter={showFilter}
            setShowFilter={setShowFilter}
          />
        ),
        timeSlotWrapper: (params) => {
          // const nurse = staff?.find?.(
          //   (resource) => resource.staffId === params.resource
          // );

          return (
            <TimeSlot
              {...params}
              // nurse={nurse}
              bookAnAppointmentClick={bookAnAppointmentClick}
            />
          );
        },
        resourceHeader: ResourceHeader,
        eventWrapper: (params) => (
          <ResourceEvent
            {...params}
            appointmentDetailClick={appointmentDetailClick}
          />
        ),
        agenda: {
          time: (params) => <AgendaTime {...params} />,
          event: (params) => (
            <Agenda
              {...params}
              appointmentDetailClick={appointmentDetailClick}
            />
          ), // with the agenda view use a different component to render events
        },
      },
      localizer: momentLocalizer(moment),
    }),
    [setView, view]
  );

  const views = useMemo(() => {
    return {
      week: true,
      month: true,
      day: true,
      agenda: MyCustomAgendaComponent,
      // dispatch_log: DispatchLog,
    };
  }, []);

  const shouldScrollToTime = moment()?.format('DD MM YYYY') === date?.format?.('DD MM YYYY')
  const location = useLocation();
  const dispatch = useDispatch()

  return (
    <BigCalendar
      scrollToTime={shouldScrollToTime ? new Date() : false}
      // selectable={true}
      elementProps={{
        style: {
          width: 200,
        },
      }}
      components={components}
      timeslots={1}
      slotPropGetter={(date, staffId, ...x) => {
        const dateMoment = moment(date);
        let hasEvent = false;
        const resource = staff?.find?.(
          (resource) => resource.staffId === staffId
        );
        if (resource?.shiftStart && resource?.shiftEnd) {
          let startShift = moment(dateMoment);
          const startShiftTime = resource.shiftStart?.split(":");
          startShift.set({
            hour: startShiftTime[0],
            minute: startShiftTime[1],
          });
          let endShift = moment(dateMoment);
          const endShiftTime = resource.shiftEnd?.split(":");
          endShift.set({ hour: endShiftTime[0], minute: endShiftTime[1] });
          if (
            dateMoment.isSameOrAfter(startShift) &&
            dateMoment.isSameOrBefore(endShift)
          ) {
            hasEvent = true;
          }
        }
        if (hasEvent) {
          return {
            className: "shiftAvailable",
            style: { backgroundColor: "#F1FDF6 !important" }, //  "#F1FDF6"
          };
        } else {
          return {};
        }
      }}
      onNavigate={(date) => {
        const momentDateFormatted = moment(date).format("DD-yy-MM")
        const qs = queryString.parse(location.search, {
          arrayFormat: "bracket",
          ignoreQueryPrefix: true
        })
        qs.date = momentDateFormatted
        dispatch(replace({
          search: queryString.stringify(qs, {
            arrayFormat: "bracket",
            ignoreQueryPrefix: true
          })
        }))


        setDate(date);
      }}
      date={date}
      view={view}
      onView={(view) => {
        setView(view);
      }}
      events={uniqBy(dailyBookings, "orderId")?.filter((booking) => {
        return currentFacilityIds.includes(booking?.facilityId);
      })}
      startAccessor={(event) => {
        return moment(event.serviceDate).toDate();
      }}
      endAccessor={(event) => {
        const durationHours = Number(event.orderDuration ?? 0);
        let date = moment(event.serviceDate);
        date = date.add(durationHours > 0 ? durationHours : 1, "hour");
        if (date.day() > moment(event.serviceDate).day()) {
          return moment(event.serviceDate).endOf("day").toDate();
        }

        return date.toDate();

      }}
      localizer={localizer}
      resources={staff}
      resourceIdAccessor={(resource) => {
        return resource.staffId;
      }}
      onDoubleClickEvent={appointmentDetailClick}
      onSelectSlot={bookAnAppointmentClick}
      onBookingAppointmentClick={bookAnAppointmentClick}
      resourceTitleAccessor="firstName"
      views={views}
      dayLayoutAlgorithm="no-overlap"
    />
  );
}

Calendar.propTypes = {};

export default Calendar;
